// extracted by mini-css-extract-plugin
module.exports = {"carousel":"da51a739f7--carousel--FCofi"};